import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref } from "vue"

const _hoisted_1 = { class: "flex flex-wrap items-center h-screen" }
const _hoisted_2 = { class: "w-1/2" }
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = { class: "mb-8" }

import { IonPage, IonContent } from '@ionic/vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import PasswordInput from '@/components/inputs/PasswordInput.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import TextInput from '@/components/inputs/TextInput.vue';

import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import AuthService from '@/classes/AuthService';

import { onMounted, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  setup(__props) {

const loader      = ref(false)
const showError   = ref(false)
const showSuccess = ref(false)
const errorMsg    = ref()
const errors      = ref([])

const form = ref({
    token: '',
    email: '',
    password: '',
    password_confirmation: '',
})

const fetchParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlParams.entries());

    form.value.token = params.token ?? null
    form.value.email = params.email ?? null
}

const submit = async () => {
    try {
        loader.value = true
        await AuthService.changePassword(form.value)
        loader.value = false
        showSuccess.value = true

        setTimeout(() => {
            window.location.replace('/login');
        }, 1500);

    }catch(error) {
        loader.value = false
        loader.value = false;
        showError.value = true;
        errorMsg.value = error.response.data.message

        if(error.response.status == 422) {
            errors.value = error.response.data.errors;
        }
    }

}

onMounted(() => fetchParams())


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), {
        fullscreen: true,
        class: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "w-1/2 text-center px-20" }, [
              _createElementVNode("div", { class: "logo-img" }, [
                _createElementVNode("img", {
                  src: "assets/logo.png",
                  alt: "logo",
                  class: "w-full max-w-[500px]"
                })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("form", {
                class: "w-[60%] mx-auto",
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
              }, [
                _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "text-lg font-bold" }, "Forgot Password", -1)),
                _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-sm text-gray-500 mb-6" }, "Kindly input your email address", -1)),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(TextInput, {
                    disabled: "",
                    type: "hidden",
                    modelValue: form.value.email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.email) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(PasswordInput, {
                    label: "New Password",
                    placeholder: "New Password",
                    modelValue: form.value.password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.password) = $event)),
                    error: errorMsg.value
                  }, null, 8, ["modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(PasswordInput, {
                    label: "Confirm Password",
                    placeholder: "Confirm Password",
                    modelValue: form.value.password_confirmation,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.password_confirmation) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode(ButtonComponent, {
                  type: 'submit',
                  class: "w-full",
                  onClick: submit,
                  disabled: loader.value
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode(" Reset Password ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "pt-6 text-center" }, [
                  _createElementVNode("a", {
                    class: "text-sm transition duration-300 hover:text-primary-500",
                    href: ""
                  }, "Return to Login")
                ], -1))
              ], 32)
            ])
          ]),
          (loader.value)
            ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(ErrorModal, {
            width: "w-[548px]",
            title: "Warning!",
            "action-text": "Close",
            "cancel-text": "Go back",
            show: showError.value,
            onClose: _cache[4] || (_cache[4] = ($event: any) => (showError.value = false)),
            onConfirm: _cache[5] || (_cache[5] = ($event: any) => (showError.value = false)),
            errors: errors.value
          }, {
            content: _withCtx(() => [
              _createTextVNode(_toDisplayString(errorMsg.value), 1)
            ]),
            _: 1
          }, 8, ["show", "errors"]),
          _createVNode(SuccessModal, {
            show: showSuccess.value,
            onCancel: _cache[6] || (_cache[6] = ($event: any) => (showSuccess.value = false)),
            onConfirm: _cache[7] || (_cache[7] = ($event: any) => (showSuccess.value = false)),
            "action-text": "Close",
            title: "Forgot Password",
            content: "Please check your email for the reset password link."
          }, null, 8, ["show"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})